import React from "react";
import { Link } from 'react-router-dom';

const Navigation = (p) => {
  const [action, store] = [p.action, p.store.getState()];
  let activeLink = '/' + decodeURIComponent(store.activeLink.split('/')[1]);
  
  if (activeLink === '/ruslingvaĵoj') 
    activeLink += '/' + decodeURIComponent(store.activeLink.split('/')[2]);
  
  const classList = (link) => {
    return "nav-link " + (activeLink === link ? 'active' : '')
  }
  const updateLink = (link) => {
    store.currentText != null && action('UPDATE_CURRENT_TEXT', null);
    action('CLOSE_MENU');
    action('UPDATE_LINK', link);
  }
  const navItems = () => {
    console.log(store.siteData.categoryList);
    if (!store.siteData || !store.siteData.categoryList) { return null }
    return (
      store.siteData.categoryList.map((item, index) => (
        <li className="nav-item" key={index}>
          {item.children ? 
            <div className="nav-item_has_submenu">
              <span className={classList(item.value)}>{item.label}</span>
              <div className="nav-item submenu">
                {item.children.map((item, index) => (
                  <Link key={index} to={item.value} onClick={() => updateLink(item.value)} className={classList(item.value)}>
                    {item.label}
                  </Link>
                )
                )}
              </div>
            </div> :
            <Link to={item.value} onClick={() => updateLink(item.value)} className={classList(item.value)}>
              {item.label}
            </Link>
          }
        </li>
      ))
    )
  }
  return (
    <nav className="navbar">
      <ul className="navbar-nav mr-auto">
        {navItems()}
      </ul>
    </nav>
  )
}


export default Navigation;